import { useTranslation } from "react-i18next";
import { wirasanaConstant } from "../utils/wirasanaConstant";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
      </div>

      <div className="container relative z-10 px-4 mx-auto md:px-8">
        {/* Main Footer Content */}
        <div className="py-16 md:py-20">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
            {/* Company Info Column */}
            <div className="space-y-6 lg:col-span-2">
              <div className="space-y-4">
                <h3 className="text-3xl font-bold text-white md:text-4xl">
                  <span className="text-[#f5272b]">WIRASANA</span> Rent a Car
                </h3>
                <p className="max-w-md text-lg leading-relaxed text-slate-300">{t("we_offer")}</p>
              </div>

              {/* Contact Info */}
              <div className="space-y-4">
                <h4 className="flex items-center gap-3 mb-4 text-xl font-bold text-white">
                  <div className="w-8 h-8 bg-[#f5272b]/10 rounded-lg flex items-center justify-center">
                    <i className="fa-solid fa-address-book text-[#f5272b]"></i>
                  </div>
                  Get In Touch
                </h4>

                <div className="space-y-3">
                  {/* Phone */}
                  <a
                    href="tel:03612860066"
                    className="flex items-center gap-4 text-slate-300 hover:text-[#f5272b] transition-colors duration-300 group"
                  >
                    <div className="w-12 h-12 bg-slate-800 group-hover:bg-[#f5272b]/10 rounded-xl flex items-center justify-center border border-slate-700 group-hover:border-[#f5272b]/30 transition-all duration-300">
                      <i className="fa-solid fa-phone text-[#f5272b]"></i>
                    </div>
                    <span className="text-base font-medium">(0361) 286-066</span>
                  </a>

                  {/* WhatsApp */}
                  <a
                    href={`https://wa.me/${wirasanaConstant.whatsapp}?text=Hello,+I+am+interested+in+knowing+more+about+your+service`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 text-slate-300 hover:text-[#f5272b] transition-colors duration-300 group"
                  >
                    <div className="w-12 h-12 bg-slate-800 group-hover:bg-[#f5272b]/10 rounded-xl flex items-center justify-center border border-slate-700 group-hover:border-[#f5272b]/30 transition-all duration-300">
                      <i className="fa-brands fa-whatsapp text-[#f5272b] text-xl"></i>
                    </div>
                    <span className="text-base font-medium">+62 812-8654-0882</span>
                  </a>

                  {/* Email */}
                  <a
                    href="mailto:info@wirasanarentacar.com"
                    className="flex items-center gap-4 text-slate-300 hover:text-[#f5272b] transition-colors duration-300 group"
                  >
                    <div className="w-12 h-12 bg-slate-800 group-hover:bg-[#f5272b]/10 rounded-xl flex items-center justify-center border border-slate-700 group-hover:border-[#f5272b]/30 transition-all duration-300">
                      <i className="fa-solid fa-envelope text-[#f5272b]"></i>
                    </div>
                    <span className="text-base font-medium break-all">info@wirasanarentacar.com</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Company Location Column */}
            <div className="space-y-6">
              <h4 className="flex items-center gap-3 text-xl font-bold text-white">
                <div className="w-8 h-8 bg-[#f5272b]/10 rounded-lg flex items-center justify-center">
                  <i className="fa-solid fa-building text-[#f5272b]"></i>
                </div>
                {t("company")}
              </h4>
              <div className="space-y-3">
                <a
                  href="#home"
                  className="flex items-start gap-3 text-slate-300 hover:text-[#f5272b] transition-colors duration-300 group"
                >
                  <i className="fa-solid fa-location-dot text-[#f5272b] mt-1 flex-shrink-0"></i>
                  <span className="text-base leading-relaxed">
                    Denpasar, Bali
                    <br />
                    Indonesia
                  </span>
                </a>
              </div>

              {/* Social Media Links */}
              <div className="pt-4">
                <h5 className="mb-3 text-sm font-semibold tracking-wide text-white uppercase">Follow Us</h5>
                <div className="flex items-center gap-3">
                  <a
                    href="https://www.facebook.com/wirasanarentacarbali"
                    className="w-10 h-10 bg-slate-800 hover:bg-[#f5272b] rounded-xl flex items-center justify-center border border-slate-700 hover:border-[#f5272b] transition-all duration-300 text-slate-300 hover:text-white"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/wirasana_rentacar"
                    className="w-10 h-10 bg-slate-800 hover:bg-[#f5272b] rounded-xl flex items-center justify-center border border-slate-700 hover:border-[#f5272b] transition-all duration-300 text-slate-300 hover:text-white"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.tiktok.com/place/Wirasana%20Rent%20A%20Car-34955879829872718"
                    className="w-10 h-10 bg-slate-800 hover:bg-[#f5272b] rounded-xl flex items-center justify-center border border-slate-700 hover:border-[#f5272b] transition-all duration-300 text-slate-300 hover:text-white"
                  >
                    <i className="fa-brands fa-tiktok"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Working Hours Column */}
            <div className="space-y-6">
              <h4 className="flex items-center gap-3 text-xl font-bold text-white">
                <div className="w-8 h-8 bg-[#f5272b]/10 rounded-lg flex items-center justify-center">
                  <i className="fa-solid fa-clock text-[#f5272b]"></i>
                </div>
                {t("working_hour")}
              </h4>
              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 border bg-slate-800/50 rounded-xl border-slate-700/50">
                  <span className="font-medium text-slate-300">Mon - Fri</span>
                  <span className="font-semibold text-white">8:00 AM - 8:00 PM</span>
                </div>
                <div className="flex items-center justify-between p-3 border bg-slate-800/50 rounded-xl border-slate-700/50">
                  <span className="font-medium text-slate-300">Saturday</span>
                  <span className="font-semibold text-white">8:00 AM - 8:00 PM</span>
                </div>
                <div className="flex items-center justify-between p-3 border bg-slate-800/50 rounded-xl border-slate-700/50">
                  <span className="font-medium text-slate-300">Sunday</span>
                  <span className="font-semibold text-white">8:00 AM - 8:00 PM</span>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="py-8 border-t border-slate-700/50">
          <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
            <p className="text-center text-slate-400 md:text-left">
              © {new Date().getFullYear()} <span className="text-[#f5272b] font-semibold">Wirasana Rent a Car</span>.
              All rights reserved.
            </p>
            {/* <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-slate-400 hover:text-[#f5272b] transition-colors duration-300 text-sm font-medium"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-slate-400 hover:text-[#f5272b] transition-colors duration-300 text-sm font-medium"
              >
                Terms of Service
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
